import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "services/api";

import { UploadImageRequest } from "./types";

export const s3BaseUrl = "https://applicationimages.s3.amazonaws.com/";

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseURL}/s3`,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

export const s3Api = createApi({
  reducerPath: "s3Service",
  baseQuery,
  endpoints: (builder) => ({
    uploadImage: builder.mutation<string, UploadImageRequest>({
      query: (uploadImageRequest: UploadImageRequest) => ({
        url: "/",
        method: "POST",
        body: uploadImageRequest,
      }),
    }),
  }),
});

export const { useUploadImageMutation } = s3Api;
